const versions = [
	"3.1.0-beta.01",
	"3.1.0-beta.02",
	"3.1.0-beta.03",
];
module.exports= versions[versions.length-1];